import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { en } from "@/content/en";
import { id } from "@/content/id";

const dictionary = { en, id };

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("samasta-lang") === "id" ? "id" : "en";
    } catch {
      return "en";
    }
  });

  const setLang = (next) => {
    try {
      localStorage.setItem("samasta-lang", next);
    } catch {
      /* storage unavailable */
    }
    setLangState(next);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = dictionary[lang].meta.title;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: dictionary[lang] }), [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
